import React from 'react'
import parse from 'html-react-parser';

const SafarieGettingThere = ({ safariViewData }) => {
  return (
    <div id="getting-there" role="tabpanel" aria-labelledby="howto-reach" className="tab-pane  accordion-item mb-3 ">
      <div className="card bg-set accordion-collapse  card_bodyPadding">
        <div className="card-body p-3">
        <div className="itenary-title">
            <h6 className="fs-6 fw-bold mb-4">Getting There</h6>
          </div>
          <div
            className="itenary_text">
            {safariViewData?.getting_there && parse(safariViewData?.getting_there)}
          </div>

        </div>
      </div>
    </div>

  )
}

export default SafarieGettingThere
